import React from 'react';

import {
  getArtifactHtmlDocumentTemplateId,
  resolveHtmlDocumentPreviewStyleId,
  type HtmlDocumentArtifactRef
} from '~/components/workspaces/lib/html-document-artifact';

/**
 * Tracks the export style chosen in the Open PDF popover and derives the style
 * ID used for iframe preview and editor stylesheet injection.
 */
export function useHtmlDocumentExportStyle(artifact: HtmlDocumentArtifactRef) {
  const linkedTemplateId = getArtifactHtmlDocumentTemplateId(artifact);

  const [selectedStyleId, setSelectedStyleId] = React.useState<string | null>(null);

  React.useEffect(() => {
    setSelectedStyleId(null);
  }, [artifact.id, artifact.version, linkedTemplateId]);

  const previewStyleId = resolveHtmlDocumentPreviewStyleId(linkedTemplateId, selectedStyleId);

  return {
    selectedStyleId,
    setSelectedStyleId,
    previewStyleId
  };
}
